module.exports = __webpack_public_path__ + "static/media/home_bg_wide.d289aa04.png";